import BigNumber from 'bignumber.js';
import Money from 'src/common/entity/basic-types/Money';
import { safeGetStorageItem, safeSetStorageItem, STORAGE_KEYS } from 'src/utils/storage';

export const convertCurrency = (amount: BigNumber, fromCurrency: string, toCurrency: string): BigNumber => {
    const exchangeRatesCookie = safeGetStorageItem(STORAGE_KEYS.EXCHANGE_RATES);
    if (!exchangeRatesCookie) {
        console.error('Invalid exchangeRates');
        return amount;
    }
    const exchangeRates: Record<string, number> = JSON.parse(exchangeRatesCookie);

    // Nothing to convert
    if (fromCurrency === toCurrency) return amount;

    let convertedAmount = amount.dividedBy(exchangeRates[fromCurrency]);

    if (toCurrency !== 'EUR') convertedAmount = convertedAmount.multipliedBy(exchangeRates[toCurrency]);

    return convertedAmount.decimalPlaces(2);
};

// Used in the Tables to sort columns with Money values
export const sortMoney = (a: any, b: any, order: 'asc' | 'desc', sortField: string) => {
    const convertToEUR = (item: any) => {
        const amount =
            item[sortField].amount instanceof BigNumber
                ? item[sortField].amount
                : new BigNumber(item[sortField].amount);

        const amountInEUR = convertCurrency(amount, item[sortField].currency, 'EUR');

        return Money.fromJson({
            amount: amountInEUR,
            currency: 'EUR',
        });
    };

    return Money.sort(convertToEUR(a), convertToEUR(b), order);
};

export const saveExchangeRates = (data: any) => {
    const entries: Record<string, string>[] = data.Cube.Cube.Cube;

    const rates: Record<string, number> = { EUR: 1 };

    entries.forEach(entry => {
        rates[entry.currency] = Number.parseFloat(entry.rate);
    });

    safeSetStorageItem(STORAGE_KEYS.EXCHANGE_RATES, JSON.stringify(rates));
};
